<template>
	<c-dialog ref="dialog" width="800" mode="slide" mask-close>
		<div class="m-ship-body">
			<!-- 订单信息 -->
			<div class="m-ship-order">
				<p>订单号：{{orderNo || '-'}}</p>
				<p>产品信息：{{productName || '-'}}</p>
				<p v-if="produceCode">背贴码：{{produceCode}}</p>
			</div>

			<!-- 发货方式 -->
			 <c-form vertical unit-width="100%" style="padding: 0;">
				<c-form-item label="发货方式" required :tip="shipType == 1 ? '线下当面交接，无需物流信息，确认后订单直接完成' : ''">
					<c-radio-group v-model="shipType" :options="shipTypeOptions"></c-radio-group>
				</c-form-item>

				<!-- 收货信息（仅邮寄发货展示，必填） -->
				<template v-if="shipType == 2">
					<c-form-item label="收货人" required>
						<c-input v-model="receiverName" placeholder="请输入收货人姓名" maxlength="50"></c-input>
					</c-form-item>
					<c-form-item label="联系电话" required>
						<c-input v-model="receiverPhone" placeholder="请输入联系电话" maxlength="20"></c-input>
					</c-form-item>
					<c-form-item label="收货地址" required>
						<c-input v-model="receiverAddress" placeholder="请输入收货地址" maxlength="200"></c-input>
					</c-form-item>
				</template>

				<!-- 邮寄发货信息 -->
				<template v-if="shipType == 2">
					<c-form-item label="快递公司" required>
						<c-select v-model="expressCompanyCode" async @search="searchLogisticsCompany" :value-data="selectedExpressCompanyData" placeholder="请选择快递公司" @change="changeExpressCompany"></c-select>
					</c-form-item>
					<c-form-item label="快递单号" required>
						<c-input v-model="expressNo" placeholder="请输入快递单号" maxlength="50"></c-input>
					</c-form-item>
				</template>
			 </c-form>
		</div>

		<template #button>
			<c-button size="dialog" color="main" :loading="submitting" @click="submitHandle">确认发货</c-button>
			<c-button size="dialog" @click="$refs.dialog.close()">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
	export default {
		name: 'offlineShipDialog',

		data() {
			return {
				submitting: false,
				orderId: '',
				orderNo: '',
				productName: '',
				produceCode: '',
				receiverName: '',
				receiverPhone: '',
				receiverAddress: '',
				shipType: 1,
				shipTypeOptions: [{
					name: '当面交接',
					value: 1
				}, {
					name: '邮寄发货',
					value: 2
				}],
				/*已选快递公司完整项[{name, value}]，用于async下拉的值回显*/
				selectedExpressCompanyData: [],
				expressCompanyCode: '',
				expressCompanyName: '',
				expressNo: ''
			}
		},

		methods: {
			/*********打开弹框**********/
			open(data = {}) {
				this.orderId = data.orderId || '';
				this.orderNo = data.orderNo || '';
				this.productName = data.productName || '';
				this.produceCode = data.produceCode || '';
				this.receiverName = data.receiverName || '';
				this.receiverPhone = data.receiverPhone || '';
				this.receiverAddress = data.receiverAddress || '';
				this.shipType = 1;
				this.expressCompanyCode = '';
				this.expressCompanyName = '';
				/*手动录单快递公司无历史回显值，重置异步下拉选中项*/
				this.selectedExpressCompanyData = [];
				this.expressNo = '';
				this.submitting = false;
				this.$refs.dialog.open({title: '发货'});
			},

			/*********异步搜索快递公司（LOGISTICS_TYPE字典，keyword映射后端name模糊查询）**********/
			searchLogisticsCompany(keyword, resolve) {
				this.request({
					url: '/dic/info/options',
					data: {
						dic_type_code: 'LOGISTICS_TYPE',
						name: keyword
					},
					success: data => {
						resolve(data || []);
					}
				});
			},

			/*********切换快递公司时同步名称（async下拉change回传完整选中项，清除时为空对象）**********/
			changeExpressCompany(data) {
				var valid = data && data.value !== undefined;
				this.selectedExpressCompanyData = valid ? [data] : [];
				this.expressCompanyName = valid ? (data.name || '') : '';
			},

			/*********确认发货**********/
			submitHandle() {
				if (this.shipType == 2) {
					if (!this.receiverName.trim()) {
						this.$message({message: '请填写收货人', type: 'warn'});
						return;
					}
					if (!this.receiverPhone.trim()) {
						this.$message({message: '请填写联系电话', type: 'warn'});
						return;
					}
					if (!this.receiverAddress.trim()) {
						this.$message({message: '请填写收货地址', type: 'warn'});
						return;
					}
					if (!this.expressCompanyCode) {
						this.$message({message: '请选择快递公司', type: 'warn'});
						return;
					}
					if (!this.expressNo.trim()) {
						this.$message({message: '请输入快递单号', type: 'warn'});
						return;
					}
				}

				var data = {
					order_id: this.orderId,
					ship_type: this.shipType
				};
				if (this.shipType == 2) {
					data.receiver_name = this.receiverName.trim();
					data.receiver_phone = this.receiverPhone.trim();
					data.receiver_address = this.receiverAddress.trim();
					data.express_company = this.expressCompanyName;
					data.express_no = this.expressNo.trim();
				}

				this.submitting = true;
				this.request({
					url: '/offline/sale/order/ship',
					data: data,
					loading: true,
					success: (data, msg) => {
						this.submitting = false;
						this.$message({message: msg || '发货成功', type: 'success'});
						this.$refs.dialog.close();
						this.$emit('resolve');
					},
					error: () => {
						this.submitting = false;
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-ship-body {
		padding: 16px 24px;
		min-height: 200px;
	}

	.m-ship-order {
		padding: 10px 16px;
		background: #f9f9f9;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		line-height: 24px;
		font-size: 13px;
		color: #333;
		margin-bottom: 12px;
	}

	.m-ship-item {
		margin-bottom: 16px;

		.m-label {
			display: block;
			margin-bottom: 8px;
			font-size: 14px;
			color: #333;

			.m-required {
				color: #f5222d;
				margin-right: 2px;
			}
		}
	}

	.m-ship-tabs {
		display: flex;
		gap: 12px;

		.m-ship-tab {
			position: relative;
			padding: 6px 24px;
			border: 1px solid #d9d9d9;
			border-radius: 4px;
			font-size: 14px;
			color: #333;
			background: #fff;
			cursor: pointer;
			transition: all .2s;
			user-select: none;

			&:hover {
				border-color: #1890ff;
				color: #1890ff;
			}

			&.z-active {
				border-color: #1890ff;
				color: #1890ff;

				&::after {
					content: '';
					position: absolute;
					right: 0;
					bottom: 0;
					width: 0;
					height: 0;
					border-style: solid;
					border-width: 0 0 10px 10px;
					border-color: transparent transparent #1890ff transparent;
				}
			}
		}
	}

	.m-ship-tip {
		margin-top: 8px;
		font-size: 13px;
		color: #999;
	}
</style>
